import type { TextFieldProps } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import type { GridBuildFormData } from '@core/core/types'
import type { Nullable } from 'common/types'
import type { FC } from 'react'

import css from './MapBuildingRightMenu.css'
import type { MapMenuProps } from './types'

const textFieldProps: TextFieldProps<string> = {
  size: 'xs',
  withClearButton: true,
  className: css.mapMenuSelect,
}

export const MapMenu: FC<MapMenuProps> = ({ mapName, updateTargetData }) => {
  const onChangeMapName = (value: Nullable<GridBuildFormData['buildInfo']['name']>) => {
    updateTargetData(() => value ?? '')
  }

  return (
    <div className={css.mapMenuTextWrapper}>
      <TextField label="Название" {...textFieldProps} value={mapName} onChange={onChangeMapName} />
    </div>
  )
}
